export const en = {
  message: "You haven't tried a Pair Report yet. It's one of the most useful things in Simpli5.",
  cta: 'Try your first Pair Report',
  ctaWithName: 'View Pair Report with %{name}',
  dismiss: 'Dismiss',
}

export const es = en
